var makeVar = (family, variant, state) => "var(--color-".concat(family, "-").concat(variant, "-").concat(state, ")");
var colors = {
  neutral: {
    surface: {
      default: makeVar('neutral', 'surface', 'default')
    },
    heavy: {
      default: makeVar('neutral', 'heavy', 'default')
    }
  },
  accentOne: {
    subdued: {
      default: makeVar('accent-one', 'subdued', 'default')
    }
  }
};
export var ListingBadgeKeys = ['displayHome', 'featuredProperty', 'topSpot', 'propertyOfTheWeek', 'development', 'new', 'priceReduced', 'underOffer', 'refreshed', 'rented', 'underApplication', 'overFiftyFiveEnabled', 'overSixtyEnabled', 'fullyFurnished', 'sold', 'offMarket', 'newLand', 'dreamHome'];
var colour = {
  accent: '#e81043',
  brandAqua: '#05ccb6',
  brandBlue: '#0063e6',
  brandYellow: '#ffa200',
  brandOrange: '#fe6d45',
  brandPurple: '#874df0',
  white: colors.neutral.surface.default
};
export var ListingBadgeValues = {
  displayHome: {
    name: 'displayHome',
    priority: 0,
    label: 'Display Home',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  featuredProperty: {
    name: 'featuredProperty',
    priority: 1,
    groupedPriority: 1,
    label: 'Featured',
    colour: colour.accent,
    textColour: colour.white
  },
  topSpot: {
    name: 'topSpot',
    group: 'featured',
    priority: 1,
    showUnless: ['featuredProperty'],
    groupedPriority: 2,
    label: 'Top Spot',
    colour: colour.accent,
    textColour: colour.white
  },
  propertyOfTheWeek: {
    name: 'propertyOfTheWeek',
    group: 'featured',
    priority: 1,
    showUnless: ['featuredProperty', 'topSpot'],
    groupedPriority: 3,
    label: 'Property of the week',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  development: {
    name: 'development',
    priority: 2,
    label: 'New Home',
    colour: colour.brandBlue,
    textColour: colour.white
  },
  new: {
    name: 'new',
    showUnless: ['underOffer', 'underApplication', 'sold', 'rented'],
    priority: 3,
    label: 'New',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  refreshed: {
    name: 'refreshed',
    showUnless: ['new'],
    priority: 3,
    label: 'Promoted',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  priceReduced: {
    name: 'priceReduced',
    priority: 4,
    label: 'New price',
    showUnless: ['new'],
    colour: colour.brandAqua,
    textColour: colour.white
  },
  underOffer: {
    name: 'underOffer',
    showUnless: ['sold'],
    priority: 5,
    label: 'Offer',
    colour: colour.brandYellow,
    textColour: colour.white
  },
  rented: {
    name: 'rented',
    priority: 6,
    label: 'Rented',
    colour: colour.brandOrange,
    textColour: colour.white
  },
  underApplication: {
    name: 'underApplication',
    showUnless: ['rented'],
    priority: 7,
    label: 'Application',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  overFiftyFiveEnabled: {
    name: 'overFiftyFiveEnabled',
    priority: 8,
    label: "Over 55's",
    colour: colour.brandPurple,
    textColour: colour.white
  },
  overSixtyEnabled: {
    name: 'overSixtyEnabled',
    priority: 9,
    label: "Over 60's",
    colour: colour.brandPurple,
    textColour: colour.white
  },
  fullyFurnished: {
    name: 'fullyFurnished',
    priority: 10,
    label: 'Furnished',
    colour: colour.brandAqua,
    textColour: colour.white
  },
  sold: {
    name: 'sold',
    priority: 11,
    label: 'Sold',
    colour: colour.brandOrange,
    textColour: colour.white
  },
  offMarket: {
    name: 'offMarket',
    priority: 12,
    label: 'Off the market',
    colour: colour.brandOrange,
    textColour: colour.white
  },
  newLand: {
    name: 'newLand',
    priority: 13,
    label: 'New Land',
    colour: colour.brandBlue,
    textColour: colour.white
  },
  dreamHome: {
    name: 'dreamHome',
    priority: 14,
    label: 'Dream Home',
    colour: colors.accentOne.subdued.default,
    textColour: colors.neutral.heavy.default
  }
};
export var ListingBadge = ListingBadgeValues;
export var ListingBadges = ListingBadge;